import { withErrorBoundary } from 'react-error-boundary';
import { css } from 'styled-components';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import { useIsMobile } from 'hooks/responsive';
import { breakpoint } from 'variables';
import ContentCard from '..';
import type { ContentCardSkeletonProps } from '../types';

const scrollContainerCss = css`
    && {
        gap: ${({ theme }) => theme.Spacing16};
        padding: 0 ${({ theme }) => theme.Spacing16};
        margin: 0 -${({ theme }) => theme.Spacing16};
        scroll-padding-inline-end: ${({ theme }) => theme.Spacing16};
        scroll-padding-inline-start: ${({ theme }) => theme.Spacing16};

        ${breakpoint.up('768px')} {
            gap: ${({ theme }) => theme.Spacing24};
        }

        ${breakpoint.up('1025px')} {
            scroll-padding-inline-end: 0;
            scroll-padding-inline-start: 0;
            padding: 0;
            margin: 0;
        }
    }
    
`;

function SkeletonSlider({
    cardsAmount = 6,
    skeletonProps
}: {
    cardsAmount?: number;
    skeletonProps?: ContentCardSkeletonProps;
}) {
    const isMobile = useIsMobile();
    const itemLength = Array.from({ length: cardsAmount });

    return (
        <DynamicItemCarousel
            gapSize={isMobile ? Spacing16 : Spacing24}
            items={itemLength}
            scrollContainerCss={scrollContainerCss}
            itemRenderer={(_, index) => {
                return <ContentCard.Skeleton key={index} {...skeletonProps} />;
            }}
        />
    );
}

export default withErrorBoundary(SkeletonSlider, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
